import React from "react";

const DefaultComp: React.FC = () => React.createElement("div", { className: "alert alert-info" }, "Pas de preview disponible dans formio");

export default DefaultComp;